'use strict';

var ngModule = 'frontend.components.head';

require('angular')
  .module(ngModule, [])
  .component('cnHead', require('./cn-head'))
  .component('cnHeadAction', require('./cn-head-action'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-head/index.js
 ** module id = 31
 ** module chunks = 0
 **/